import type { StateCreator } from 'zustand';

export interface ForecastSessionSlice {
  forecastSessionRedirectSuppressed: boolean;
  setForecastSessionRedirectSuppressed: (isSuppressed: boolean) => void;
}

export const forecastSessionSlice: StateCreator<
  ForecastSessionSlice,
  [],
  [],
  ForecastSessionSlice
> = (set) => ({
  forecastSessionRedirectSuppressed: false,
  setForecastSessionRedirectSuppressed: (forecastSessionRedirectSuppressed) =>
    set({ forecastSessionRedirectSuppressed }),
});
